import { createSlice } from '@reduxjs/toolkit';
import { IApiState } from 'interfaces/api';
import {
  ICustomerItem,
  ICustomerObject,
} from 'pages/Shared/DealerCustomers/Models';

export interface ICustomerDetailState extends IApiState {
  data: ICustomerObject;
}

export const CONFIRMATION_ACTIONS = {
  INVITE: 'INVITE',
  UPDATE: 'UPDATE',
};

const initialContactPermissions = {
  showInfoToOutOfMaintenanceUsers: false,
};

const initialContactData = {
  id: 0,
  zipCode: '',
  city: '',
  state: '',
  country: '',
  phone: '',
  email: '',
  webUrl: '',
  address1: '',
  address2: '',
  address3: '',
  district: '',
  permissions: initialContactPermissions,
};

const initialCustomerData = {
  title: '',
  salutation: '',
  firstName: '',
  lastName: '',
  position: '',
  company: '',
  contactInformation: initialContactData,
  customerId: '',
};

export const customerInitialState: ICustomerDetailState = {
  data: {
    dealerCustomerId: 0,
    dealerInfo: {
      id: 0,
      dealerId: '',
      dealerName: '',
    },
    customerInfo: initialCustomerData,
  },
};

export const customerItemInitialState: ICustomerItem = {
  dealerCustomerId: 0,
  dealerInfo: {
    id: 0,
    dealerId: '',
    dealerName: '',
  },
  customerInfo: {
    firstName: '',
    lastName: '',
  },
};

export const customerItemSlice = createSlice({
  name: 'customerItem',
  initialState: customerItemInitialState,
  reducers: {},
});
